<template>
  <div v-if="customer.term" class="ta-bidding-limit">
    <label class="ta-bidding-limit-label">{{ $t('Bidding Limit') }}:</label>
    <div v-if="customer.term.credit_limit && defaultCurrency" class="ta-bidding-limit-value">{{ customer.term.credit_limit | asCurrency(defaultCurrency) }}</div>
    <div v-else class="ta-bidding-limit-value">({{ $t('No Bidding Limit Set') }} )</div>
    <b-button variant="outline-primary" size="sm" @click="openModal">
      {{ $t('Request increase') }}
    </b-button>

    <b-modal
      ref="biddingLimitModal"
      :title="$t('Request Bidding Limit Increase')"
      :visible="showModal"
      @hide="closeModal"
      static
      lazy
    >
      <b-form-group :label="$t('Select your desired limit')">
        <b-form-select v-model="selectedLimit" :options="limitOptions"></b-form-select>
      </b-form-group>

      <template #modal-footer>
        <b-button variant="secondary" @click="closeModal" :disabled="loading">
          {{ $t('Cancel') }}
        </b-button>
        <b-button variant="primary" @click="submitRequest" :disabled="loading || !selectedLimit">
          <b-spinner v-if="loading" small class="mr-1"></b-spinner>
          {{ $t('Submit') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {mapState, mapMutations, mapGetters} from 'vuex'
import axiosClient from "@/services/axios";

const limitOptionBase = [
  { value: '10000', amount: 10000 },
  { value: '25000', amount: 25000 },
  { value: '50000', amount: 50000 },
  { value: '100000', amount: 100000 },
  { value: '-100000', amount: 100000 },
];

export default {
  name: "BiddingLimit",
  data() {
    return {
      defaultLabel: this.$t("Credit Limit"),
      showModal: false,
      selectedLimit: null,
      loading: false,
    }
  },
  computed: {
    ...mapState(['customer']),
    ...mapGetters(['defaultCurrency']),
    limitOptions() {
      const currency = this.defaultCurrency;
      const formatAmount = amount => {
        if (currency) {
          return this.$options.filters.asCurrency(amount, currency);
        }
        return amount.toLocaleString('en-US');
      };

      return [
        { value: null, text: this.$t('Please select a limit') },
        ...limitOptionBase.map(option => ({
          value: option.value,
          text: option.value.startsWith('-')
            ? `${this.$t('Above')} ${formatAmount(option.amount)}`
            : `${this.$t('Up to')} ${formatAmount(option.amount)}`
        }))
      ];
    }
  },
  methods: {
    ...mapMutations(['showNotification']),
    openModal() {
      this.selectedLimit = null;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    async submitRequest() {
      this.loading = true;
      try {
        const response = await axiosClient.post('website/request-bidding-limit-increase', {
          requested_limit: this.selectedLimit
        });
        if (response.status === 200) {
          this.showNotification({
            title: this.$t('Success'),
            text: this.$t('Your request has been submitted successfully'),
            variant: 'success'
          });
          this.closeModal();
        }
      } catch (err) {
        const message = err.response?.data?.error || this.$t('An error occurred while submitting your request');
        this.showNotification({
          title: this.$t('Error'),
          text: message,
          variant: 'danger'
        });
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ta-bidding-limit {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

#artisioTimedAuctions {
  .ta-bidding-limit-label {
    margin: 0;
  }
}
</style>
